import { JobName } from "@enums";
export const softwareJobs = [
  JobName.software0,
  JobName.software1,
  JobName.software2,
  JobName.software3,
  JobName.software4,
  JobName.software5,
  JobName.software6,
  JobName.software7,
];
export const itJobs = [JobName.IT0, JobName.IT1, JobName.IT2, JobName.IT3];
export const netEngJobs = [JobName.networkEng0, JobName.networkEng1];
export const businessJobs = [
  JobName.business0,
  JobName.business1,
  JobName.business2,
  JobName.business3,
  JobName.business4,
  JobName.business5,
];
export const securityJobs = [JobName.security0, JobName.security1, JobName.security2, JobName.security3];
export const agentJobs = [JobName.agent0, JobName.agent1, JobName.agent2];
export const softwareConsultJobs = [JobName.softwareConsult0, JobName.softwareConsult1];
export const businessConsultJobs = [JobName.businessConsult0, JobName.businessConsult1];
